import { IAdditionalDriver, IDriverBase, IListOption, IDriver, IDriverOption } from "../classes/Domain";
import React from "react";
import { ListGroup, Collapse } from "react-bootstrap";
import Utilities from "../classes/Utilities";
import Select from 'react-select'
import { Rifm } from 'rifm';
import { Alert } from 'react-bootstrap';
import ValidatableFormGroup from "./ValidatableFormGroup";
import { validationUtils, IValidationFailure } from "../validation/Validation";
import StateList from "./StateList";
import { FULL_QUOTE_STEPS } from "../AppConstants";

interface IProps {
    disabled: boolean,
    driverOptions: Array<IDriverOption>,
    additionalDriver: IAdditionalDriver,
    driverIndex: number,
    getDriverSelection(driverIndex: number, status: string): IDriverOption,
    onDriverStatusChange(driver: IDriverBase, driverIndex: number, option: IListOption | null): void,
    onDriverDataChange(value: any, driver: IDriverBase, driverIndex: number, property: string): void
}

interface IState {
    key: string,
    errors?: Array<IValidationFailure> | null;
}

class AdditionalDriver extends React.Component<IProps, IState>
{
    constructor(props: IProps) {
        super(props);

        this.state = {
            key: Utilities.uniqueId() + "_" + this.props.additionalDriver.driver.id,
            errors: null
        }
    }

    componentDidMount() {
        this.setState({ ...this.state, errors: null });

        var uid = FULL_QUOTE_STEPS.ADDITIONAL_DRIVERS + "_" + this.props.additionalDriver.driver.id;

        validationUtils.subscribeToValidationFailure(uid,
            validationData => {
                this.setState({ ...this.state,  errors: validationData });
            });
    }

    componentWillUnmount() {
        var uid = FULL_QUOTE_STEPS.ADDITIONAL_DRIVERS + "_" + this.props.additionalDriver.driver.id;

        validationUtils.unsubscribeFromValidationFailure(uid);
    }

    render() {
        return (
            <ListGroup.Item key={this.state.key + "_listGroup"}>
                <label className="left-cell">
                    <span>
                        {this.props.additionalDriver.driver.firstName} {this.props.additionalDriver.driver.lastName}
                    </span>
                </label>
                <label className="right-cell">
                    <Select
                        key={this.state.key + "_select"}
                        options={this.props.driverOptions}
                        value={this.props.getDriverSelection(this.props.driverIndex, this.props.additionalDriver.status)}
                        onChange={(v) => this.props.onDriverStatusChange(this.props.additionalDriver.driver, this.props.driverIndex, v ? { value: v["value"], label: v["label"] } : null)}
                        isClearable={false}
                        isDisabled={this.props.disabled}
                    />
                </label>
                <Collapse in={this.props.getDriverSelection(this.props.driverIndex, this.props.additionalDriver.status)?.value === "ADD"} key={this.state.key + "_collapse"}>
                    <div key={this.state.key + "_div"}>
                        <Alert variant={"warning"}>
                            <h5 className="text-center">Please check driver info!</h5>
                            <ValidatableFormGroup
                                key={this.state.key + "_licenseNumber"}
                                label="Driver's License Number"
                                className="col-left"
                                value={this.props.additionalDriver.driver.licenseNumber}
                                placeholder="Driver's License Number"
                                validated={null !== this.state.errors}
                                validationError={validationUtils.getValidationErrorFor(this.state.errors, "licenseNumber")}
                                onChange={(e) => { this.props.onDriverDataChange(e.target.value, this.props.additionalDriver.driver, this.props.driverIndex, "licenseNumber"); validationUtils.setValidationErrorFor(this.state.errors, "licenseNumber", "") }}
                                disabled={this.props.disabled}
                            />

                            <StateList
                                key={this.state.key + "_licenseState"}
                                label="Driver's License State"
                                className="col-right"
                                value={this.props.additionalDriver.driver.licenseState}
                                validated={null !== this.state.errors}
                                validationError={validationUtils.getValidationErrorFor(this.state.errors, "licenseState")}
                                onChange={(state) => { this.props.onDriverDataChange(state?.value ?? "", this.props.additionalDriver.driver, this.props.driverIndex, "licenseState"); validationUtils.setValidationErrorFor(this.state.errors, "licenseState", "") }}
                                disabled={this.props.disabled}
                            />

                            <Rifm
                                key={this.state.key + "_birthDate"}
                                accept={/\d/g}
                                mask={!!this.props.additionalDriver.driver && 10 <= this.props.additionalDriver.driver.birthDate?.length}
                                format={Utilities.formatDate}
                                value={this.props.additionalDriver.driver.birthDate ?? ""}
                                onChange={(v) => { this.props.onDriverDataChange(v, this.props.additionalDriver.driver, this.props.driverIndex, "birthDate") }}>
                                {({ value, onChange }) => (
                                    <ValidatableFormGroup
                                        label="Birthdate"
                                        placeholder="mm/dd/yyyy"
                                        value={value}
                                        validated={null !== this.state.errors}
                                        validationError={validationUtils.getValidationErrorFor(this.state.errors, "birthDate")}
                                        onChange={(e) => { onChange(e); validationUtils.setValidationErrorFor(this.state.errors, "birthDate", "") }}
                                        pattern="[0-9]*"
                                        inputmode="numeric"
                                        disabled={this.props.disabled}
                                    />
                                )}
                            </Rifm>
                        </Alert>
                    </div>
                </Collapse>
            </ListGroup.Item>
            );
    }
}

export default AdditionalDriver;